// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__18p4T","footer":"ReportModalFilter_footer__32UAA"};